import { useState } from "react";
import useDialog from "../../../../hooks/useDialog";

export const useResetConfirmDialog = () => {
    
  const dialogStatus = useDialog();
  const [callbacks, setCallbacks] = useState({
    "reset" : () => {},
    "return" : () => {}
  });

  const openDialog = () => {
    dialogStatus.open();
  }

  const setOnReset = (onResetFunc) => {
    setCallbacks((prev) => ({
      ...prev,
      "reset": onResetFunc
    }))
  }

  const setOnReturn = (onReturnFunc) => {
    setCallbacks((prev) => ({
      ...prev,
      "return": onReturnFunc
    }))
  }
  
  const doReturn = () => {
    dialogStatus.onClose(null)();
    callbacks["return"]();
  }

  const doReset = () => {
    dialogStatus.onClose(null)();
    callbacks["reset"]();
  }
  
  return {
    openDialog,
    setCallbacks,
    setOnReset,
    setOnReturn,
    dialogParams : {
      isOpen: dialogStatus.isOpen,
      doReturn,
      doReset
    }
  }
}